<template>
  <div class="container mx-auto ml-5 lg:px-0">
    <!-- Bouton pour ouvrir la modale -->
    <div
      class="flex w-full sm:w-1/2 md:w-1/3 justify-center items-center md:justify-end ml-0 md:ml-[60%] xl:ml-[50%] my-5 sm:my-3 lg:mt-[10%] xl:mt-[-6%]">
      <button class="bg-navigation hover:bg-primaire text-white font-bold py-2 px-4 rounded-lg shadow-lg"
        @click="openModal"
        aria-label="Ouvrir le formulaire" title="Ouvrir le formulaire pour signaler un animal perdu">
        Ouvrir le formulaire
      </button>
    </div>

    <!-- Modale -->
    <div v-if="isModalOpen" class="modal-fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-modal-white w-full max-w-3xl rounded-lg shadow-lg p-6 relative">
        <!-- Bouton pour fermer la modale -->
        <button class="absolute top-2 right-2 text-gray-500 hover:text-gray-700" @click="closeModal"
          aria-label="Fermer la modale" title="Fermer la modale">
          ✖
        </button>

        <!--formulaire-->
        <div class="container w-full mx-auto">
          <div class="w-full mx-auto sm:px-6 lg:px-8 mb-12 mt-10">
            <div class="bg-gray-100 w-full shadow rounded p-8 sm:p-12">
              <h3 class="text-xl sm:2xl md:text-3xl font-bold leading-7 text-center text-navigation">Formulaire à
                compléter
              </h3>
              <div class="espace_10"></div>
              <p class="text-xl text-center text-gray-700">Si vous avez des questions, n'hésitez pas à nous écrire à
                info@animauxdesecondechance.com</p>

              <form id="form" action="/backend/submit_animauxperdus.php" method="POST" @submit="onSubmit"
                novalidate>
                <input type="hidden" name="redirect" value="https://animauxdelasecondechance.ca/confirmation-message"
                aria-label="redirection" tabindex="0">

                <div class="md:flex items-center mt-12">
                  <div class="w-full md:w-1/2 flex flex-col">
                    <label class="font-semibold leading-none text-gray-500">J'ai perdu :</label>
                    <select id="evenement" v-model="form.evenement"
                      class="custom-select leading-none text-white p-3 focus:outline-none focus:border-navigation mt-4 border-0 bg-navigation rounded"
                      title="Évènement" name="evenement" aria-label="evenement" tabindex="0" required>
                      <option value="" disabled>Choisissez un animal</option>
                      <option value="chat">Mon chat</option>
                      <option value="chien">Mon chien</option>
                    </select>
                  </div>
                </div>
                <div class="md:flex items-center mt-5">
                  <div class="w-full md:w-1/2 flex flex-col">
                    <label class="font-semibold leading-none text-gray-500">Votre nom<span class="text-red-500">
                        *</span></label>
                    <input type="text" v-model="form.nom"
                      class="leading-none text-grisfonce p-3 focus:outline-none focus:border-primaire mt-4 border-0 bg-white rounded"
                      name="nom" aria-label="nom" tabindex="0" placeholder="Nom de famille" required>
                    <span v-if="erreurs.nom" id="nom-Error" class="text-red-500 font-bold bg-gray-200 px-2 mt-1 mb-2">{{
                      erreurs.nom }}</span>
                  </div>
                  <div class="w-full md:w-1/2 flex flex-col md:ml-6 md:mt-0 mt-4">
                    <label class="font-semibold leading-none text-gray-500">Votre prénom<span class="text-red-500">
                        *</span></label>
                    <input type="text" v-model="form.prenom"
                      class="leading-none text-grisfonce p-3 focus:outline-none focus:border-primaire mt-4 border-0 bg-white rounded"
                      name="prenom" aria-label="prenom" tabindex="0" placeholder="Votre prénom" required>
                    <span v-if="erreurs.prenom" id="prenom-Error"
                      class="text-red-500 font-bold bg-gray-200 px-2 mt-1 mb-2">{{ erreurs.prenom }}</span>
                  </div>
                </div>

                <div class="md:flex items-center mt-5">
                  <div class="w-full md:w-1/2 flex flex-col">
                    <label class="font-semibold leading-none text-gray-500">Courriel<span
                        class="text-red-500 pl-1">*</span></label>
                    <input type="email" v-model="form.email"
                      class="leading-none text-grisfonce p-3 focus:outline-none focus:border-primaire mt-4 border-0 bg-white rounded"
                      name="email" aria-label="courriel" tabindex="0" placeholder="Courriel" required>
                    <span v-if="erreurs.email" id="email-Error"
                      class="text-red-500 font-bold bg-gray-200 px-2 mt-1 mb-2">{{ erreurs.email }}</span>
                  </div>
                  <div class="w-full md:w-1/2 flex flex-col md:ml-6 md:mt-0 mt-4">
                    <label class="font-semibold leading-none text-gray-500">Téléphone<span
                        class="text-red-500 pl-1">*</span></label>
                    <input v-model="form.tel" id="tel" pattern="[0-9]{10}"
                      title="Veuillez entrer un numéro de téléphone valide (10 chiffres)"
                      class="leading-none text-grisfonce p-3 focus:outline-none focus:border-primaire mt-4 border-0 bg-white rounded"
                      name="tel" type="tel" aria-label="téléphone" tabindex="0" placeholder="Téléphone" required>
                    <span v-if="erreurs.tel" id="tel-Error" class="text-red-500 font-bold bg-gray-200 px-2 mt-1 mb-2">{{
                      erreurs.tel }}</span>
                  </div>
                </div>

                <div class="md:flex items-center mt-5">
                  <div class="w-full md:w-1/2 flex flex-col">
                    <label class="font-semibold leading-none text-gray-500">Nom de l'animal<span class="text-red-500">
                        *</span></label>
                    <input type="text" v-model="form.nomAnimal"
                      class="leading-none text-grisfonce p-3 focus:outline-none focus:border-primaire mt-4 border-0 bg-white rounded"
                      name="nomAnimal" aria-label="nomAnimal" tabindex="0" placeholder="Nom de de l'animal" required>
                    <span v-if="erreurs.nomAnimal" id="nomAnimal-Error" class="text-red-500 font-bold bg-gray-200 px-2 mt-1 mb-2">{{ erreurs.nomAnimal }}</span>
                  </div>
                  <div class="w-full md:w-1/2 flex flex-col md:ml-6 md:mt-0 mt-4">
                    <label class="font-semibold leading-none text-gray-500">Âge de l'animal<span class="text-red-500">
                        *</span></label>
                    <input type="text" v-model="form.ageAnimal" maxlength="2" pattern="[0-9]{1,2}"
                      title="Veuillez entrer un âge valide (1 ou 2 chiffres)"
                      class="leading-none text-grisfonce p-3 focus:outline-none focus:border-primaire mt-4 border-0 bg-white rounded"
                      name="ageAnimal" aria-label="ageAnimal" tabindex="0" placeholder="L'âge de votre animal" required>
                    <span id="ageAnimal-Error" class="text-red-500 font-bold bg-gray-200 px-2 mt-1 mb-2"></span>
                  </div>
                </div>

                <div class="grid grid-cols-12 gap-4 w-full pt-5"> <!-- Changement ici -->
                  <div class="col-span-12 sm:col-span-6 flex flex-col justify-evenly items-stretch">
                    <label class="font-semibold leading-none text-gray-500">Date perdu :<span class="text-red-500">
                        *</span></label>
                    <input type="date" v-model="form.dateAnimalPerdu" id="dateAnimalPerdu" :max="today"
                      class="leading-none text-grisfonce p-3 focus:outline-none focus:border-primaire mt-4 border-0 bg-white rounded"
                      name="dateAnimalPerdu" aria-label="dateAnimalPerdu" tabindex="0" required>
                    <span id="dateAnimalPerdu-Error" class="text-red-500 font-bold bg-gray-200 px-2 mt-1 mb-2"></span>
                  </div>
                  <div class="col-span-12 sm:col-span-6 flex flex-col justify-evenly items-stretch">
                    <label class="font-semibold leading-none text-gray-500">Secteur perdu :<span class="text-red-500">
                        *</span></label>
                    <input type="text" v-model="form.secteurPerdu" id="secteurPerdu"
                      class="leading-none text-grisfonce p-3 focus:outline-none focus:border-primaire mt-4 border-0 bg-white rounded"
                      name="secteurPerdu" aria-label="secteurPerdu" tabindex="0" placeholder="Secteur perdu" required>
                    <span id="secteurPerdu-Error" class="text-red-500 font-bold bg-gray-200 px-2 mt-1 mb-2"></span>

                  </div>
                </div>
                <div class="col-span-12 flex-start flex-col justify-between">
                  <h3 class="font-semibold text-gray-500 mt-3 mb-5">Sélectionnez le sexe de votre animal<span
                      class="text-red-500 pl-1"> *</span></h3>
                  <ul class="items-center w-full text-sm font-medium text-gray-900 sm:flex h-auto">
                    <li
                      class="w-48 bg-navigation border-gray-200 rounded-lg mr-4 sm:border-b-0 sm:border-r dark:border-gray-600">
                      <div class="flex items-center pl-3">
                        <input id="male" type="radio" name="maleFemelle" value="male" v-model="form.sexeAnimal" required
                          class="w-4 h-4 text-action bg-gray-100 border-gray-500 rounded focus:ring-action dark:focus:ring-action dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                        <label for="male" class="w-full py-3 ml-2 text-sm font-bold text-white" aria-label="mâle">Mâle</label>
                      </div>
                    </li>
                    <li class="w-48 bg-navigation border-gray-200 rounded-lg mr-4 sm:border-b-0 sm:border-r">
                      <div class="flex items-center pl-3">
                        <input id="femelle" type="radio" name="maleFemelle" value="femelle" v-model="form.sexeAnimal"
                          required class="w-4 h-4 text-action bg-navigation border-gray-500 rounded focus:ring-action">
                        <label for="femelle" class="w-full py-3 ml-2 text-sm font-bold text-white" aria-label="femelle">Femelle</label>
                      </div>
                    </li>
                  </ul>
                  <span v-if="erreurs.sexeAnimal" id="sexeAnimal-Error"
                    class="md:flex items-center mx-auto w-full px-2 mt-3 text-red-500 font-bold bg-gray-200 text-center">{{
                    erreurs.sexeAnimal }}</span>
                </div>

                <div class="w-full flex flex-col mt-5">
                  <label class="font-semibold leading-none text-gray-500">Ajouter une ou plusieurs images<span
                      class="text-red-500"> *</span></label>
                  <input type="file" id="images" name="images[]" accept="image/*" multiple required @change="onFileChange"
                    class="leading-none text-grisfonce p-3 focus:outline-none focus:border-primaire mt-4 border-0 bg-white rounded"
                    aria-label="images" tabindex="0">
                  <span v-if="erreurs.image" id="images-Error"
                    class="text-red-500 font-bold bg-gray-200 px-2 mt-1 mb-2">{{ erreurs.image }}</span>
                </div>

                <div>
                  <div class="w-full flex flex-col mt-8">
                    <label class="font-semibold leading-none text-gray-500">Autres informations pertinentes
                      (description,
                      collier,
                      médaille etc.)<span class="text-red-500 font-bold"> &nbsp;*</span></label>
                    <textarea v-model="form.message"
                      class="h-40 text-base leading-none text-grisfonce p-3 focus:outline-none focus:border-purple-700 mt-4 bg-white border-0 rounded"
                      name="message" aria-label="message" tabindex="0" placeholder="Message" required></textarea>
                  </div>
                </div>

                <div class="flex items-center justify-center w-full">
                  <input id="submit-button"
                    class="shadow-sm bg-action hover:bg-navigation text-white font-bold py-2 px-4 mt-6 rounded focus:outline-none focus:shadow-outline cursor-pointer"
                    type="submit" title="Envoyez" value="Envoyez  ➤"
                    aria-label="Envoyer le formulaire">
                  <input 
                    class="shadow bg-navigation hover:bg-primaire text-white font-bold py-2 px-4 mt-6 ml-6 rounded focus:outline-none focus:shadow-outline cursor-pointer"
                    type="reset" aria-label="Réinitialiser le formulaire" title="réinitialiser">
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useRecaptcha } from '../composables/useRecaptcha.js';
import { validateForm } from '../composables/validateFormAnimauxPerdus';

const router = useRouter();

const isModalOpen = ref(false);
const { loadRecaptcha, executeRecaptcha } = useRecaptcha('6LcWWiwrAAAAAAX71p6me0HWoPzX0zTxNaw_R9ml');
const erreurs = ref({});


function openModal() {
  isModalOpen.value = true;
}

function closeModal() {
  isModalOpen.value = false;
}

const form = ref({
  evenement: "",
  nom: '',
  prenom: '',
  email: '',
  tel: '',
  nomAnimal: '',
  ageAnimal: '',
  dateAnimalPerdu: '',
  secteurPerdu: '',
  sexeAnimal: '',
  images: [],
  message: ''
});

// Initialiser dateAnimalPerdu à aujourd'hui au format YYYY-MM-DD
const today = new Date().toISOString().split('T')[0];
form.value.dateAnimalPerdu = today;

function onFileChange(event) {
  form.value.images = Array.from(event.target.files);
}

function onSubmit(e) {
  e.preventDefault();
  console.log("onSubmit appelé");

  if (validateForm(form.value, erreurs.value)) {
    console.log('Validation réussie !');

    loadRecaptcha()
      .then(() => executeRecaptcha('submit'))
      .then(token => {
        const formData = new FormData(document.getElementById('form'));

        // Ajout manuel des fichiers issus de la variable reactive (si besoin)
        if (form.value.images && form.value.images.length > 0) {
          form.value.images.forEach((file) => {
            formData.append('images[]', file);
          });
        }

        formData.append('g-recaptcha-response', token);

        return fetch('/backend/submit_animauxperdus.php', {
          method: 'POST',
          body: formData,
        });
      })
      .then(async res => {
        const text = await res.text();
        console.log("Réponse brute du backend :", text);
        try {
          return JSON.parse(text);
        } catch (e) {
          console.error("Erreur parsing JSON :", e);
          throw e;
        }
      })
      .then(data => {
        if (data.success) {
          router.push('/confirmation-message');
        } else {
          console.error(data.message || "Erreur lors de l'envoi");
        }
      })
      .catch(error => {
        console.error("Erreur lors de l'envoi du formulaire :", error);
      });
  } else {
    console.log("Validation échouée !", erreurs.value);
  }
}

</script>

<style scoped>
.modal-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  overflow-y: auto;
  /* Permet le défilement si le contenu dépasse la hauteur de l'écran */
  padding: 1rem;
  /* Ajoute un espace autour de la modale */
}

/* Contenu de la modale */
.bg-modal-white {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  max-width: 800px;
  /* Augmente la largeur maximale de la modale */
  width: 100%;
  max-height: 90vh;
  /* Limite la hauteur de la modale à 90% de la hauteur de l'écran */
  overflow-y: auto;
  /* Permet le défilement à l'intérieur de la modale si le contenu dépasse */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>